module.exports = __webpack_public_path__ + "img/Step02.7db858db.webp";